/**
 *
 * Img.js
 *
 * Renders an image, enforcing the usage of the alt="" tag
 */

import * as React from 'react';

interface Props {
  src: string | object;
  alt: string;
  className?: string;
}
function Img({ alt, className, src }: Props) {
  return <img className={className} src={src as string} alt={alt} />;
}

export default Img;
